
import Vue from "vue";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";
import axios from "axios";
import { INVOICE_ENDPOINT } from "../constants/EndPoints";
import { IInvoiceData, IAppProperties, IAuthBasic } from "../types";
import AuthBasic from "../data/authBasic";
import store from "../store";
import { HTTP_STATUS } from "../constants/HttpStatusCode";
import InvoiceSelector from "@/components/InvoiceSelector.vue";
import SearchHelp from "@/components/SearchHelp.vue";

export default Vue.extend({
  mixins: [fieldEntryMixin, AppPropsMixin],
  components: { InvoiceSelector, SearchHelp },
  data: function() {
    return {
      sapDocNumber: "" as string,
      searchNumber: "" as string,
      sapLength: 10 as number,
      refLength: 16 as number,
      hasMultiInvoices: false as boolean,
      showSnackbar: false,
      snackBarText: "No Invoice Found",
      snackBarColor: "info",
      isHelpVisible: false
    };
  },
  computed: {
    invoices: {
      get(): IInvoiceData[] {
        //@ts-ignore
        return store.getters.invoiceModule.getInvoiceData;
      },
      set(newValue: IInvoiceData[]) {
        //@ts-ignore
        store.commit.invoiceModule.SET_INVOICE_DATA(newValue);
        this.$emit("invoiceupdated", newValue);
      }
    },
    invoiceSelections: {
      get(): IInvoiceData[] {
        //@ts-ignore
        return store.getters.invoiceModule.getInvoiceData;
      },
      set(newValue: IInvoiceData[]) {
        //@ts-ignore
        store.commit.invoiceModule.SET_INVOICE_SELECTIONS(newValue);
      }
    },
    requestPaymentPlanButtonTooltip(): string {
      //@ts-ignore
      return this.doesNotQualifyForPaymentPlan() ? this.messageFormatConsolidated(this.appProps.doesNotQualifyVerbiage, [this.appProps.financeEmail]) : "Request Payment Plan";
    },
    paymentPlanRequestButtonDisabled(): boolean {
      return this.doesNotQualifyForPaymentPlan();
    }
  },
  methods: {
    openPaymentPlanDialog() {
      //@ts-ignore
      this.$parent.$refs.invoiceDetails.$refs.paymentPlanSignupDialog.isOpen = true;
    },
    doesNotQualifyForPaymentPlan(): boolean {
      //@ts-ignore
      return this.invoices.length == 0 || !this.invoices[0].referenceNumber.startsWith(this.appProps.paymentPlanQualifyingInvoiceReferencePrefix)
      || this.dunningBlockHasSomething();
    },
    dunningBlockHasSomething() {
      return this.invoices[0].dunningBlock !== "undefined" && this.invoices[0].dunningBlock != null && this.invoices[0].dunningBlock != '';
    },
    showHelp() {
      this.isHelpVisible = true;
    },
    closeHelp() {
      this.isHelpVisible = false;
    },
    invoiceSelected(selectedInvoice: string) {
      this.sapDocNumber = selectedInvoice;
      this.searchByDocNumber();
      this.hasMultiInvoices = false;
    },
    searchByDocNumber() {
      if (this.isDocNumberValid()) {
        this.invoices = [];

        //@ts-ignore
        this.appProps.loadingInvoice = true;

        let url = INVOICE_ENDPOINT.GET_BY_DOC_NUM.replace(
          "{REPLACE_WITH_ID}",
          this.sapDocNumber
        );

        axios
          .get(url, { auth: AuthBasic })
          .then(response => {
            if (response.status === HTTP_STATUS.OK) {
              this.invoices = response.data;
            } else if (response.status === HTTP_STATUS.NO_CONTENT) {
              this.snackBarText =
                "No invoice found matching the provided SAP Document Number.";
              this.showSnackbar = true;
              this.snackBarColor = "info";
            } else {
              this.snackBarText = response.status + ": " + response.statusText;
              this.showSnackbar = true;
              this.snackBarColor = "info";
            }
          })
          .catch(error => {
            this.snackBarText =
              error.response.status + ": " + error.response.statusText;
            this.showSnackbar = true;
            this.snackBarColor = "error";
          })
          .finally(() => {
            //@ts-ignore
            this.appProps.loadingInvoice = false;
          });
      }
    },
    searchByNumber() {
      if (this.searchNumber.length > 0) {
        this.invoices = [];
        this.invoiceSelections = [];

        //@ts-ignore
        this.appProps.loadingInvoice = true;

        let url = INVOICE_ENDPOINT.GET_BY_REF_DOC_NUM;

        axios
          .get(url, { params: { number: this.searchNumber }, auth: AuthBasic })
          .then(response => {
            if (response.status === HTTP_STATUS.OK) {
              this.invoices = response.data;
            } else if (response.status === HTTP_STATUS.NO_CONTENT) {
              this.snackBarText =
                "No invoice found matching the provided Search Number.";
              this.showSnackbar = true;
              this.snackBarColor = "info";
            } else {
              this.snackBarText = response.status + ": " + response.statusText;
              this.showSnackbar = true;
              this.snackBarColor = "info";
            }
          })
          .catch(error => {
            if (error.response.status === HTTP_STATUS.MULTIPLE_CHOICES) {
              //@ts-ignore
              this.invoiceSelections = error.response.data;
              this.hasMultiInvoices = true;
            } else {
              this.snackBarText =
                error.response.status + ": " + error.response.statusText;
              this.showSnackbar = true;
              this.snackBarColor = "error";
            }
          })
          .finally(() => {
            //@ts-ignore
            this.appProps.loadingInvoice = false;
          });
      }
    },
    keyupSearchIfEnter(event: KeyboardEvent) {
      //@ts-ignore
      if (this.searchNumber.length > 1 && this.isReturnKey(event)) {
        this.searchByNumber();
      }
    },
    isDocNumberValid(): boolean {
      //@ts-ignore
      let doesStartWith: any = this.rules.sapDocumentNumberStartWith(
        this.sapDocNumber
      );
      //@ts-ignore
      let isValidLength: any = this.rules.sapDocumentNumberLength(
        this.sapDocNumber
      );
      return doesStartWith === true && isValidLength === true;
    }
  }
});
